import { Box, Card, Chip, IconButton, Typography } from "@mui/material";
import { OrganizationNiche } from "schemas/dashboard";

import { Template } from "features/Influencer/ContactList/schema";
import { generateColorFromString } from "utils/color";

import TemplateChip from "./TemplateChip";
import styles from "./styles";

interface Props {
  niche: OrganizationNiche;
  editNiche: (niche: OrganizationNiche) => void;
  fallbackTemplates: Template[];
}
const NicheCard = ({ niche, editNiche, fallbackTemplates }: Props) => {
  const getNicheTemplates = () => {
    if (niche?.templates && niche.templates.length > 0) {
      return niche?.templates;
    } else {
      return [];
    }
  };

  return (
    <Card sx={styles.card} onClick={() => editNiche(niche)}>
      <Box sx={{ position: "absolute", top: 10, right: 10 }}>
        <IconButton sx={{ color: "black", fontSize: 13 }}>
          <Box component="i" className="fa-thin fa-pen-line" />
        </IconButton>
      </Box>

      <Box>
        <Typography sx={{ fontFamily: "Open Sans", fontWeight: 400, mb: 2 }}>
          Niche
        </Typography>
        <Chip
          size="small"
          sx={{
            backgroundColor: generateColorFromString(
              niche.name,
              "tagColorPalette",
            ),
            fontSize: 14,
            px: 1,
            mb: 3,
          }}
          label={niche.name}
        />
      </Box>

      <Box>
        <Typography variant="caption" color="textSecondary">
          Templates
        </Typography>

        {getNicheTemplates()?.map((template) => (
          <TemplateChip key={template.id} template={template} />
        ))}
        {getNicheTemplates()?.length === 0 && (
          <Typography sx={{ color: "warning.main" }}>
            <Box
              component="i"
              className="fa-regular fa-warning"
              sx={{ mr: 1 }}
            />
            No templates set. Click edit to set your templates.
          </Typography>
        )}
      </Box>
    </Card>
  );
};

export default NicheCard;
